import { HierarchyUtils } from '@inter-ikea-core/core';
import { BehaviorParameters } from 'rangeConfig/@types';

/**
 * Either adds the product to the target (selected entity) or replaces all
 * existing target children of same product type with the new product
 */

const addOrReplaceAtTarget = ({
  coreApi,
  props,
  rootState: {
    products: { inMarket: products }
  }
}: BehaviorParameters) => {
  const productId = props.coreProductIds ? props.coreProductIds[0] : props.coreProductId;
  const product = products.find(({ coreProductId }) => coreProductId === productId);
  const target = coreApi.entities.findSelectedEntity();

  if (!target || !product) return;

  const currentlyAtTarget = HierarchyUtils.children(target).filter(
    d => coreApi.entities.getProductType(d) === product.type
  );

  if (currentlyAtTarget.length) {
    currentlyAtTarget.forEach(entity => {
      coreApi.products.replace(entity.id, productId);
    });
  } else {
    const result = coreApi.products.addToTarget(productId, target);

    if (!result.valid && result.errors.length) {
      coreApi.entities.disposeCollidingEntities(result.errors);
    }
  }
};

export default addOrReplaceAtTarget;
